import script from "./AddSaleCategoryCompanyModal.vue?vue&type=script&setup=true&lang=js"
export * from "./AddSaleCategoryCompanyModal.vue?vue&type=script&setup=true&lang=js"

import "./AddSaleCategoryCompanyModal.vue?vue&type=style&index=0&id=8d61e7fc&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8d61e7fc"]])

export default __exports__